<div class="welcome-first-time">
  <p class="onboarding-welcome">
    {{ "modals.welcome_first_time_onboarding.welcome" | translate: { name: userName } }}
  </p>

  <div class="onboarding-layout">
    <section class="text-card description-card">
      <p>{{ "modals.welcome_first_time_onboarding.description" | translate }}</p>
    </section>

    <section class="text-card support-card">
      <p>{{ "modals.welcome_first_time_onboarding.supportMessage" | translate }}</p>
    </section>
  </div>
</div>
